exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "ul[data-v-23cfd976]{display:flex;flex-direction:row;justify-content:left;margin:10px 0;flex-wrap:wrap}ul li[data-v-23cfd976]{display:flex;flex-direction:column;align-items:center;padding:.375rem .75rem;border-radius:.25rem;box-shadow:0 3px 6px rgba(0,0,0,.16078);margin-left:10px}ul li .total-date[data-v-23cfd976]{font-size:10px}ul li span[data-v-23cfd976]{font-size:14px}", ""]);

// exports
